import { render, staticRenderFns } from "./ChannelLanding.vue?vue&type=template&id=3b4d921f&scoped=true&"
import script from "./ChannelLanding.vue?vue&type=script&lang=js&"
export * from "./ChannelLanding.vue?vue&type=script&lang=js&"
import style0 from "./ChannelLanding.vue?vue&type=style&index=0&id=3b4d921f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d921f",
  null
  
)

export default component.exports